import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { uniqueId } from "@faire/web--source/common/server-side-rendering/uniqueId";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { trackRetailerMobileAppsflyerQrcodeFailed } from "@faire/web-api--source/events/retailerMobile/actionUnknown/appsflyerQrcodeFailed";
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
export var AppsFlyerQRCode = function(param) {
    var fallbackQrCodeUrl = param.fallbackQrCodeUrl, qrCodeWidth = param.qrCodeWidth;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(true), 2), showAppsFlyerQRCode = _useState[0], setShowAppsFlyerQRCode = _useState[1];
    var QR_CODE_ID = uniqueId("appsflyer_qr_code");
    useEffect(function() {
        var _getWindow_AF_SMART_SCRIPT, _getWindow;
        // AF_SMART_SCRIPT is a script added to Google Tag Manager on prod
        // Manually inject script to test on local/staging
        // doc: https://dev.appsflyer.com/hc/docs/onelink-smart-script-v2web-to-app-url-generator#create-a-qr-code-with-the-smart-script-result
        // script: https://tagmanager.google.com/?authuser=1#/container/accounts/1798415649/containers/7538127/workspaces/1000085/tags/140
        var displayQrCode = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_AF_SMART_SCRIPT = _getWindow.AF_SMART_SCRIPT) === null || _getWindow_AF_SMART_SCRIPT === void 0 ? void 0 : _getWindow_AF_SMART_SCRIPT.displayQrCode;
        if (displayQrCode) {
            displayQrCode(QR_CODE_ID);
        } else {
            setShowAppsFlyerQRCode(false);
            trackRetailerMobileAppsflyerQrcodeFailed();
        }
    }, [
        QR_CODE_ID
    ]);
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(QrCodeWrapper, {
        id: QR_CODE_ID,
        $qrCodeWidth: qrCodeWidth,
        children: showAppsFlyerQRCode ? null : /*#__PURE__*/ _jsx(FallbackQRCodeImage, {
            src: optimizeImageUrl({
                url: fallbackQrCodeUrl
            }, isSSR, {
                height: qrCodeWidth,
                width: qrCodeWidth
            }),
            alt: strictLocalize({
                id: "4+RZKq",
                defaultMessage: [
                    {
                        type: 0,
                        value: "QR code linking to an app store"
                    }
                ]
            })
        })
    });
};
var FallbackQRCodeImage = styled.img.withConfig({
    componentId: "sc-81dfa758-0"
})([
    "max-width:100%;max-height:100%;"
]);
var QrCodeWrapper = styled.div.withConfig({
    componentId: "sc-81dfa758-1"
})([
    "",
    ""
], function(param) {
    var $qrCodeWidth = param.$qrCodeWidth;
    return css([
        "max-width:",
        ";> canvas{width:",
        ";}"
    ], getSpacing($qrCodeWidth), getSpacing($qrCodeWidth));
});
